import React from 'react';

import { Flex, Stack } from '@chakra-ui/react';
import { useRouter } from 'next/navigation';
import { GoPeople } from 'react-icons/go';

import { PrimaryButton } from '@components/custom-buttons';
import AppliedExpertise from '@modules/find-mentor/components/sections/AppliedExpertise';
import { paths } from '@routes/path';

import ExpertiseDropdown from './ExpertiseDropdown';
import SearchBox from './SearchBox';

const FindMentorDesktopView = () => {
    const router = useRouter();

    const findMentor = () => {
        router.push(paths.general.findMentor);
    };
    return (
        <Stack>
            <Flex flexDir="row" border="2px" color="border" h={12} borderRadius={8}>
                <SearchBox />
                <Stack justifyContent="center" alignItems="center">
                    <GoPeople fontSize={26} />
                </Stack>
                <Stack color="shadowSlate" marginLeft={4}>
                    <ExpertiseDropdown />
                </Stack>
            </Flex>
            <PrimaryButton buttonLabel="Find Mentor" onClick={findMentor} type="button" />
            <AppliedExpertise />
        </Stack>
    );
};

export default FindMentorDesktopView;
